/*
 * @Description: 下载文件
 */

import axios from './axios.js';
import { translate } from './i18n/index.js';

// ---------------------------------------------------------------------------

function download(url, filename) { // 下载安排表等文件 
	//有的URL是带了HOST的，这种就不要拼接了
	let downloadUrl = url;
	if (url && !url.startsWith(this.globalData.Host)) {
		downloadUrl = this.globalData.Host + url;
	}

	axios({
			url: downloadUrl, // 必填，下载资源的url
			method: 'GET',
			responseType: 'blob', // 重要，设置响应数据类型为blob,
			withCredentials: true
		})
		.then((response) => {
			// 创建一个Blob对象，使用响应数据
			const blob = new Blob([response.data]); // 根据文件类型设置MIME类型
			const url = window.URL.createObjectURL(blob);
			// 创建一个临时的a标签用于下载
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', filename); // 设置下载的文件名
			document.body.appendChild(link);
			link.click();
			// 清除临时的a标签
			document.body.removeChild(link);
		})
		.catch((error) => {
			console.error(getApp().translate('FILE_DOWNLOAD_FAILED'), error);
		});
}

// ---------------------------------------------------------------------------

/**
 * 处理富文本中的网络资源地址
 * @param {Object} data
 */
function dealRes(data) {
	if (!data) return data;
	const host = this.globalData.Host;
	data = data.replace(/\u0022\/nxcloud\/resource\/showResource/g, '\u0022\/OA\/nxcloud\/resource\/showResource');
	data = data.replace(/\u0022\/OA\/nxcloud\/resource\/showResource/g, `\u0022${host}\/OA\/nxcloud\/resource\/showResource`);
	return data;
}

// ---------------------------------------------------------------------------

export default {
	value: {},
	method: {
		download,
		dealRes,
	}
};